import { createFileRoute } from '@tanstack/react-router'
import {
  profileQueryOptions,
  quickStatsQueryOptions,
  overallProgressQueryOptions,
  continueWatchingQueryOptions,
  liveEventsQueryOptions,
  enrolledCoursesQueryOptions,
} from '@/lib/queries/dashboard'
import { achievementsListQueryOptions, achievementsSummaryQueryOptions } from '@/lib/queries/achievements'
import { recentPostsQueryOptions } from '@/lib/queries/community'
import { WelcomeHero } from '@/components/dashboard/welcome-hero'
import { QuickStats } from '@/components/dashboard/quick-stats'
import { CommunityPreview } from '@/components/dashboard/community-preview'
import { LiveClasses } from '@/components/dashboard/live-classes'
import { AchievementsGrid } from '@/components/dashboard/achievements-grid'

export const Route = createFileRoute('/_app/')({
  loader: async ({ context }) => {
    await Promise.allSettled([
      context.queryClient.prefetchQuery(profileQueryOptions()),
      context.queryClient.prefetchQuery(quickStatsQueryOptions()),
      context.queryClient.prefetchQuery(overallProgressQueryOptions()),
      context.queryClient.prefetchQuery(continueWatchingQueryOptions()),
      context.queryClient.prefetchQuery(liveEventsQueryOptions()),
      context.queryClient.prefetchQuery(enrolledCoursesQueryOptions()),
      context.queryClient.prefetchQuery(achievementsListQueryOptions()),
      context.queryClient.prefetchQuery(achievementsSummaryQueryOptions()),
      context.queryClient.prefetchQuery(recentPostsQueryOptions()),
    ])
  },
  component: DashboardPage,
})

function DashboardPage() {
  return (
    <div className="space-y-6 max-w-7xl mx-auto">
      <WelcomeHero />
      <QuickStats />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <CommunityPreview />
        <LiveClasses />
      </div>

      <AchievementsGrid />
    </div>
  )
}
